import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useDrop } from 'react-dnd';

import imageSources from '../../../../../../constants/imageSources/imageSources';
import * as columnItemActions from '../../../../../../actions/columnItem';
import * as itemTypes from '../../../../../../constants/itemTypes/itemTypes';
import { IContent } from '../../../../../../types/content';

interface IProps {
    blockIndex: string;
    columnIdx: string;
}

interface Item {
    itemType: string;
    draggedBlockIndex: string;
    draggedColumnIdx: string;
    draggedColumnItemIdx: string;
    content: IContent;
}

const ColumnItemPlaceholderDropZone: FC<IProps> = ({ blockIndex, columnIdx }) => {
    const dispatch = useDispatch();

    const [{ isOverCurrent, shouldRender }, drop] = useDrop({
        accept: [itemTypes.CUSTOMIZED_BLOCK_COLUMN_ITEM, itemTypes.STATIC_BLOCK_COLUMN_ITEM],
        drop: (item: Item, monitor) => {
            const dragType = monitor.getItemType();
            if (dragType === itemTypes.STATIC_BLOCK_COLUMN_ITEM) {
                const { itemType } = item;
                dispatch(
                    columnItemActions.addNewColumnItem({
                        blockIndex,
                        columnIdx,
                        itemType,
                    })
                );
            } else if (dragType === itemTypes.CUSTOMIZED_BLOCK_COLUMN_ITEM) {
                const { draggedBlockIndex, draggedColumnIdx, draggedColumnItemIdx, content, itemType } = item;
                dispatch(
                    columnItemActions.moveColumnItemContentToAnotherColumn({
                        draggedBlockIndex,
                        draggedColumnIdx,
                        draggedColumnItemIdx,
                        blockIndex,
                        columnIdx,
                        content,
                        type: itemType,
                    })
                );
            }
        },
        collect: (monitor) => ({
            isOverCurrent: monitor.isOver({ shallow: true }),
            shouldRender: monitor.canDrop(),
        }),
    });

    if (!shouldRender) {
        return null;
    }

    return (
        <div
            ref={drop}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundImage: isOverCurrent
                    ? `url("${imageSources.DROP_ZONE.ELEMENT.HIGHLIGHTED}")`
                    : `url("${imageSources.DROP_ZONE.ELEMENT.NOT_HIGHLIGHTED}")`,
                outline: 'none',
            }}
        >
            <span
                style={{
                    textAlign: 'center',
                    fontSize: 13,
                    color: 'black',
                    fontWeight: 'bold',
                    background: 'white',
                    position: 'absolute',
                    width: 120,
                    height: 20,
                    top: 'calc(50% - 10px)',
                    left: 'calc(50% - 60px)',
                }}
            >
                {isOverCurrent ? 'Drop Element' : 'Drop zone'}
            </span>
        </div>
    );
};

export default ColumnItemPlaceholderDropZone;
